/** How loud a card is allowed to be, and the one vocabulary for it. */
export const ATTENTION_TIERS = ["routine", "timely", "important"];
/** The tier before this one was named "important". Rows minted then still read. */
const LEGACY_TIERS = { urgent: "important" };
/** Reads a tier off untrusted data, accepting the old spelling. Null when it is not one. */
export function attentionTierFrom(value) {
    if (typeof value !== "string")
        return null;
    if (ATTENTION_TIERS.includes(value))
        return value;
    return LEGACY_TIERS[value] ?? null;
}
/** What a member reads for the tier, on a chip or a peek row. */
export function attentionTierLabel(tier) {
    if (tier === "important")
        return "Important";
    if (tier === "timely")
        return "Timely";
    return "Routine";
}
//# sourceMappingURL=attention-tier.js.map